import SubHeader from "../../components/header/SubHeader";
import Button from "../../components/common/button/Button";
import React, {useEffect} from "react";
import Form from "../../components/common/form/Form";
import {getFormData} from "../../models/vendorModel";
import {vendorSchema} from "../../schema/vendorSchema";
import {useNavigate} from "react-router-dom";
import {createVendor} from "../../store/vendor-slice";
import {useDispatch, useSelector} from "react-redux";
import {fetchExpenseList} from "../../store/list-slice";

const VendorAdd = () => {
    const dispatch = useDispatch();
    const navigator = useNavigate();
    const {createStatus, error} = useSelector(state => state.vendor);
    const userRole = useSelector((state) => state.auth.selectedRole);

    const list = useSelector(state => state.list);

    useEffect(() => {
        if (createStatus === "success") {
            navigator(".."); // Adjust the navigation path as needed
        }
    }, [createStatus, navigator]);

    const formSubmitHandler = (data) => {
        const payload = {
            id: userRole.scopeId,
            ...data,
        }
        dispatch(createVendor({...userRole, data: payload}));
    };

    const formCancelHandler = () => {
        navigator(".."); // Adjust the navigation path as needed
    };

    useEffect(() => {
        dispatch(fetchExpenseList())
    }, [dispatch])

    const schema = vendorSchema({list});
    const initialData = getFormData();
    return (
        <>
            <SubHeader title="Add Vendor">
                <Button to=".." className="btn-sm bg-secondary bg-opacity-50">Back</Button>
            </SubHeader>
            <div className="container p-0 ms-0">
                <div className="row">
                    <div className="col-xl-8">
                        <Form
                            onFormSubmit={formSubmitHandler}
                            onFormCancel={formCancelHandler}
                            schema={schema}
                            inline={false}
                            initialData={initialData}
                            status={createStatus}
                            error={error}
                        />
                    </div>
                </div>
            </div>
        </>
    )
}
export default VendorAdd;